import { FetchAPI } from "../Main/fetchAPI";
import { CLIENT } from "../constants";

export const TelehealthLocation = {
    getTelehealthLocations: () => FetchAPI.getJson({
        urlStr: `${CLIENT}/telehealthlocations`
    })
}